var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9358 2.83333H11.0641C5.90748 2.83333 2.83331 5.90749 2.83331 11.0642V22.9217C2.83331 28.0925 5.90748 31.1667 11.0641 31.1667H22.9216C28.0783 31.1667 31.1525 28.0925 31.1525 22.9358V11.0642C31.1666 5.90749 28.0925 2.83333 22.9358 2.83333ZM24.8341 10.6675L13.8975 21.6042H18.1758C18.7566 21.6042 19.2383 22.0858 19.2383 22.6667C19.2383 23.2475 18.7566 23.7292 18.1758 23.7292H11.3333C10.7525 23.7292 10.2708 23.2475 10.2708 22.6667V15.8242C10.2708 15.2433 10.7525 14.7617 11.3333 14.7617C11.9141 14.7617 12.3958 15.2433 12.3958 15.8242V20.1025L23.3325 9.16583C23.545 8.95333 23.8141 8.85416 24.0833 8.85416C24.3525 8.85416 24.6216 8.95333 24.8341 9.16583C25.245 9.57666 25.245 10.2567 24.8341 10.6675Z",
    fill: "#3C3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport1);
export default __webpack_public_path__ + "static/media/import-1.a3fd30629ee6690da67ea19c442ceb65.svg";
export { ForwardRef as ReactComponent };